module.exports = __webpack_public_path__ + "img/Hands-On Field Experience1.8d8b63ee.png";